const doc = [({"zh_tw":({"adminConstantRoomPlanDisplayType":({"default":"預設", "noImage":"暫無計畫圖片", "onlyOne":"只有一個", "onlyPlan":"限計劃"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;